export default __webpack_public_path__ + "static/frame3-491583cad75b33aade6692198564c9b5.jpg";